import { SYNTHETIC_DATA_DEMO_PDF } from '@/features/chat/demo/syntheticDataDemoContent.part01.js'
import { SYNTHETIC_DATA_DEMO_ARTIFACT_ID } from '@/features/chat/demo/syntheticDataDemoArtifact.js'
import { resolveSyntheticDataDemoPdfPage } from '@/features/chat/demo/resolveSyntheticDataDemoPdfPage.js'
import { emitDocumentPreviewOpenRequested } from './documentPreviewEvents.js'

/** @param {string} sectionId */
export function openSyntheticDataDocumentSection(sectionId) {
  emitDocumentPreviewOpenRequested({
    artifactId: SYNTHETIC_DATA_DEMO_ARTIFACT_ID,
    kind: 'pdf',
    fileName: SYNTHETIC_DATA_DEMO_PDF,
    description: 'PDF · 22 pages',
    focusSectionId: sectionId,
    focusPage: resolveSyntheticDataDemoPdfPage(sectionId),
  })
}
